import { render } from "./ConsulterEvaluation.vue?vue&type=template&id=135516cd"
import script from "./ConsulterEvaluation.vue?vue&type=script&lang=js"
export * from "./ConsulterEvaluation.vue?vue&type=script&lang=js"

import exportComponent from "/data/opt/gitlab-runner/working-directory/podman-stable_v4.8.1/corpo/crp-cardex-webapp/src/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__